import { render, staticRenderFns } from "./JobBoardList.vue?vue&type=template&id=d13beb4a&"
import script from "./JobBoardList.vue?vue&type=script&lang=js&"
export * from "./JobBoardList.vue?vue&type=script&lang=js&"
import style0 from "./JobBoardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports